import { AppEnvVariables } from "../../constants/environment.constants";
import { API_URL } from "../../constants/api.constants";
import { getLanguageCode } from "../../utilities/helper";
import { kf1AuthenticatedHttpClient } from "kfone-frontend-core";

const getPrePopulatedSearches = async (countrycode: string) => {
  const language = getLanguageCode();

  return await kf1AuthenticatedHttpClient({
    method: "GET",
    url:
      AppEnvVariables.SJPR_API_URL +
      API_URL.POPULAR_RECENT_SERACH +
      "?countrycode=" +
      countrycode +
      "&language=" +
      language
  });
};

const getJobSearchList = async (countrycode: string, keyword: string) => {
  const language = getLanguageCode();
  return await kf1AuthenticatedHttpClient({
    method: "GET",
    url:
      AppEnvVariables.SJPR_API_URL +
      API_URL.JOB_PRICING_SERACH +
      "?countrycode=" +
      countrycode +
      "&language=" +
      language +
      "&searchstring=" +
      keyword
  });
};

export { getPrePopulatedSearches, getJobSearchList };
